import React, { Suspense, Component } from "react";

class DynamicImportErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    const isChunkError =
      error?.name === "ChunkLoadError" ||
      /Failed to fetch dynamically imported module/i.test(error?.message || "") ||
      /Loading chunk .* failed/i.test(error?.message || "") ||
      /error loading dynamically imported module/i.test(error?.message || "");

    if (isChunkError) {
      const storageKey = `chunk_reload_${window.location.pathname}`;
      const lastReload = sessionStorage.getItem(storageKey);
      if (!lastReload) {
        sessionStorage.setItem(storageKey, "true");
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      const isChunkError =
        this.state.error?.name === "ChunkLoadError" ||
        /Failed to fetch dynamically imported module/i.test(this.state.error?.message || "") ||
        /Loading chunk .* failed/i.test(this.state.error?.message || "") ||
        /error loading dynamically imported module/i.test(this.state.error?.message || "");

      if (isChunkError) {
        return (
          <div
            style={{
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "24px",
              background: "#F4F7FB",
              fontFamily: "inherit",
              textAlign: "center",
            }}
          >
            <div
              style={{
                maxWidth: "420px",
                background: "#FFFFFF",
                borderRadius: "16px",
                padding: "32px 24px",
                boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#0E1421" }}>
                Update Available
              </h3>
              <p style={{ margin: 0, fontSize: "14px", color: "#64748B", lineHeight: "20px" }}>
                A newer version of the application is available. Please reload the page to continue.
              </p>
              <button
                type="button"
                onClick={() => {
                  sessionStorage.clear();
                  window.location.reload();
                }}
                style={{
                  background: "#00BADA",
                  color: "#FFFFFF",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 24px",
                  fontSize: "14px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Reload Page
              </button>
            </div>
          </div>
        );
      }
    }
    return this.props.children;
  }
}

const Loadable = (Component, customFallback = null) => (props) => (
  <DynamicImportErrorBoundary>
    <Suspense
      fallback={
        customFallback || (
          <div
            style={{
              minHeight: "100vh",
              background: "#F4F7FB",
              width: "100%",
            }}
          />
        )
      }
    >
      <Component {...props} />
    </Suspense>
  </DynamicImportErrorBoundary>
);

export default Loadable;